import React from "react";
import { connect } from "react-redux";

import {
  sortNumbers,
  createNumberRange,
  removeItem,
  capitalizeFirst,
  formatMonthsPlaceholder,
  formatDatesPlaceholder
} from "utils";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Tooltip from "App/common/ui/Tooltip";

function BackupPlanMonthly(props) {
  const monthsEnumList = Object.entries(props.enums.Months)
    .sort((a, b) => a[1] - b[1])
    .slice(1);
  const monthDaysEnumList = Object.values(props.enums.MonthDays)
    .sort((a, b) => a - b)
    .slice(1);
  monthDaysEnumList.pop();
  const LastDayKey = props.enums.MonthDays.LAST_DAY;
  const [openedDropdown, setOpenDropdown] = React.useState("");

  function updateMonths(key) {
    let months = [...props.planSettings.scheduleInfo.months];
    if (key === "all" && months.length === 12) {
      months = [];
    } else if (key === "all" && months.length < 12) {
      months = createNumberRange(12);
    } else if (months.includes(key)) {
      months = removeItem(months, months.indexOf(key));
    } else {
      months.push(key);
      months = sortNumbers(months);
    }
    props.setPlanSettings({
      ...props.planSettings,
      scheduleInfo: { ...props.planSettings.scheduleInfo, months }
    });
  }

  function updateMonthDays(key) {
    let monthDays = [...props.planSettings.scheduleInfo.monthDays];
    if (key === "all" && monthDays.length === 32) {
      monthDays = [];
    } else if (key === "all" && monthDays.length < 32) {
      monthDays = createNumberRange(32);
    } else if (monthDays.includes(key)) {
      monthDays = removeItem(monthDays, monthDays.indexOf(key));
    } else {
      monthDays.push(key);
      monthDays = sortNumbers(monthDays);
    }
    props.setPlanSettings({
      ...props.planSettings,
      scheduleInfo: { ...props.planSettings.scheduleInfo, monthDays }
    });
  }

  const containsAllDays = arr => {
    return createNumberRange(31).every(num => arr.includes(num));
  };

  return (
    <>
      <div className="idapp__schedule idapp-monthly__schedule">
        <div className="idapp-selectmonths-dropdown">
          <span className="idapp-form__label">Select Months:</span>
          <ClickAwayListener
            onClickAway={() =>
              openedDropdown === "month" && setOpenDropdown("")
            }
          >
            <div
              className="select_box_scheduler"
              onClick={() => setOpenDropdown("month")}
            >
              <Tooltip
                title={formatMonthsPlaceholder(
                  props.planSettings.scheduleInfo.months,
                  props.enums.Months
                )}
                placement="top"
              >
                <div
                  className={
                    "dropdown_select wide " +
                    (openedDropdown === "month" ? "open" : "")
                  }
                  tabIndex={0}
                >
                  <span className="current">
                    {props.planSettings.scheduleInfo.months.length === 0
                      ? "Select Months"
                      : formatMonthsPlaceholder(
                          props.planSettings.scheduleInfo.months,
                          props.enums.Months
                        )}
                  </span>
                  <div className="list">
                    <ul>
                      {monthsEnumList.map((month, index) => {
                        return (
                          <li className="option" key={index}>
                            <div className="check">
                              <input
                                id={`month-${index}`}
                                type="checkbox"
                                className={`input_checkbox ${
                                  props.planSettings.scheduleInfo.months.includes(
                                    month[1]
                                  )
                                    ? "checked"
                                    : ""
                                }`}
                                onChange={() => updateMonths(month[1])}
                              />
                              <label
                                htmlFor={`month-${index}`}
                                id={`month_label${index}`}
                              >
                                {capitalizeFirst(month[0])}
                              </label>
                            </div>
                          </li>
                        );
                      })}
                      <li className="option">
                        <div className="check">
                          <input
                            type="checkbox"
                            className={`input_checkbox ${
                              props.planSettings.scheduleInfo.months.length ===
                              12
                                ? "checked"
                                : ""
                            }`}
                            id="month-all"
                            tabIndex="0"
                            onChange={() => updateMonths("all")}
                          />
                          <label htmlFor="month-all" id="month-all_label">
                            All Months
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </Tooltip>
            </div>
          </ClickAwayListener>
        </div>
        <div className="idapp-selectdates-dropdown">
          <span className="idapp-form__label">Select Dates:</span>
          <ClickAwayListener
            onClickAway={() =>
              openedDropdown === "monthDays" && setOpenDropdown("")
            }
          >
            <div
              className="select_box_scheduler"
              onClick={() => setOpenDropdown("monthDays")}
            >
              <Tooltip
                title={formatDatesPlaceholder(
                  props.planSettings.scheduleInfo.monthDays
                )}
                placement="top"
              >
                <div
                  className={
                    "dropdown_select wide " +
                    (openedDropdown === "monthDays" ? "open" : "")
                  }
                  tabIndex={0}
                >
                  <span className="current">
                    {props.planSettings.scheduleInfo.monthDays.length === 0
                      ? "Select Days"
                      : formatDatesPlaceholder(
                          props.planSettings.scheduleInfo.monthDays
                        )}
                  </span>
                  <div className="list">
                    <ul>
                      {monthDaysEnumList.map((monthDay, index) => (
                        <li className="option" key={index}>
                          <div className="check">
                            <input
                              type="checkbox"
                              className={`input_checkbox ${
                                props.planSettings.scheduleInfo.monthDays.includes(
                                  monthDay
                                )
                                  ? "checked"
                                  : ""
                              }`}
                              id={`month-days-${index}`}
                              tabIndex="0"
                              onChange={() => updateMonthDays(monthDay)}
                            />
                            <label
                              htmlFor={`month-days-${index}`}
                              id={`month-days_label${index}`}
                            >
                              {monthDay}
                            </label>
                          </div>
                        </li>
                      ))}
                      <li className="option">
                        <div className="check">
                          <input
                            type="checkbox"
                            className={`input_checkbox ${
                              props.planSettings.scheduleInfo.monthDays.includes(
                                LastDayKey
                              )
                                ? "checked"
                                : ""
                            }`}
                            id="month-days-last-day"
                            tabIndex="0"
                            onChange={() => updateMonthDays(LastDayKey)}
                          />
                          <label
                            htmlFor="month-days-last-day"
                            id="month-days-last-day_label"
                          >
                            Last day of the month
                          </label>
                        </div>
                      </li>
                      <li className="option">
                        <div className="check">
                          <input
                            type="checkbox"
                            className={`input_checkbox ${
                              props.planSettings.scheduleInfo.monthDays
                                .length >= 31 &&
                              containsAllDays(
                                props.planSettings.scheduleInfo.monthDays
                              )
                                ? "checked"
                                : ""
                            }`}
                            id="month-days-all"
                            tabIndex="0"
                            onChange={() => updateMonthDays("all")}
                          />
                          <label
                            htmlFor="month-days-all"
                            id="month-days-all_label"
                          >
                            All Days
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </Tooltip>
            </div>
          </ClickAwayListener>
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    enums: state.common.enums
  };
}

export default connect(mapStateToProps)(BackupPlanMonthly);
